import { useCallback } from 'react';

import type { SaveSearchParamsOrKey } from '@/redux/modules/search/save/saveSearch.helpers';

import { useAppDispatch } from '@/redux/hooks';
import { submitSaveSearch } from '@/redux/modules/search/save/saveSearch.actions';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

/**
 * Follows a search and tells the bidder when savedsearch-api refused it for invalid facet values,
 * which otherwise fails silently: the follow button just stays unfollowed.
 */
export const useSubmitSaveSearch = () => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();

    return useCallback(
        (saveSearchParams: SaveSearchParamsOrKey, sendAlert: boolean) => {
            dispatch(
                submitSaveSearch({
                    feedback: {
                        invalidFacets: {
                            description: String(
                                formatMessage(['toastMessages', 'descriptions', 'searchNotSavedInvalidFilters'])
                            ),
                            title: String(formatMessage(['toastMessages', 'titles', 'searchNotSaved'])),
                        },
                    },
                    saveSearchParams,
                    sendAlert,
                })
            );
        },
        [dispatch, formatMessage]
    );
};
